import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as dropdownActions from "../../../../actions/dropdowns.actions";
import * as companyActions from "../../../../actions/company.actions";
import * as userActions from "../../../../actions/user.actions";

import AdminCompanyEditBilling from "../components/AdminCompanyEditBilling";

class AdminCompanyEditBillingContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.dropdownActions.getCompanyPaymentMethods();
    this.props.dropdownActions.getCompanyPaymentTerms();
  }

  handleSubmit(data) {
    const id = _.get(data, "id");

    if (id) {
      this.props.companyActions.updateCompanyPayment(data.company_id, data);
    } else {
      this.props.companyActions.createCompanyPayment(data);
    }
  }

  render() {
    return (
      <AdminCompanyEditBilling
        onSubmit={this.handleSubmit}
        paymentMethods={this.props.paymentMethods}
        paymentTerms={this.props.paymentTerms}
        companyId={this.props.match.params.companyId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    paymentMethods: state.dropdowns.companyPaymentMethods.data,
    paymentTerms: state.dropdowns.companyPaymentTerms.data
  };
};

const mapDispatchToProps = dispatch => ({
  companyActions: bindActionCreators(companyActions, dispatch),
  dropdownActions: bindActionCreators(dropdownActions, dispatch),
  userActions: bindActionCreators(userActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanyEditBillingContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/company/containers/AdminCompanyEditBillingContainer.js